import { useIsMobile } from '@/hooks/use-mobile'
import { OrderbookTableContentBaseProps } from './OrderbookTableContentBase'
import { OrderbookTableContentMobile } from './OrderbookTableContentMobile'
import { OrderbookTableContentDesktop } from './OrderbookTableContentDesktop'

/**
 * Unified OrderbookTableContent component that renders mobile or desktop version
 * Uses useIsMobile hook to conditionally render the appropriate version
 * This approach separates mobile and desktop code completely
 * No CSS classes mixing - pure conditional rendering
 */
export const OrderbookTableContent = (props: OrderbookTableContentBaseProps) => {
  const isMobile = useIsMobile()

  // Completely separate mobile and desktop rendering
  // No CSS classes mixing - pure conditional rendering
  if (isMobile) {
    const { sortColumn, sortDirection, ...mobileProps } = props
    return <OrderbookTableContentMobile {...mobileProps} />
  }

  return <OrderbookTableContentDesktop {...props} />
}

